module.exports = __webpack_public_path__ + "static/EnmTX_BosSimeon_L_A_cl-402de55ccfb1ad66219f4826ffe2f386.gif";